/* Move Shopify's own preferences button, preserving its event handlers. */
(() => {
  const placePreferences = () => {
    const banner = document.getElementById('shopify-pc__banner');
    const policy = banner?.querySelector('#shopify-pc__banner__body-policy-link');
    const preferences = banner?.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!policy || !preferences || policy.parentElement === preferences.parentElement) return;
    const separator = document.createElement('span');
    separator.textContent = ' · ';
    separator.setAttribute('aria-hidden', 'true');
    policy.after(separator, preferences);
  };
  const start = () => {
    placePreferences();
    new MutationObserver(placePreferences).observe(document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
